import React, { useMemo } from "react";
import Draggable from "react-draggable";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import MaterialImage from "pages/components/MaterialImage";

function PaperComponent(props) {
  return (
    <Draggable
      handle=".draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], input, textarea, select, button'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function AnaliseVendasMaterialDetalheDialog({
  open,
  onClose,
  material,
  linhas,
  loading,
  imgsByRef,
}) {
  const columns = useMemo(
    () => [
      {
        Header: "Data",
        accessor: "faturadata",
        Cell: ({ value }) => {
          if (!value) return "";

          const texto = String(value);
          return texto.length >= 10 ? texto.slice(0, 10) : texto;
        },
      },
      {
        Header: "Nº Fatura",
        accessor: "faturanumero",
      },
      {
        Header: "Quantidade",
        accessor: "quantidade",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Valor total",
        accessor: "valortotal",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Litros",
        accessor: "volume",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Peso bruto",
        accessor: "pesobruto",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Cliente",
        accessor: "cliente",
        Cell: ({ row }) => {
          const nome = row.original.cliente || "";
          const nif = row.original.clientenif || "";

          return nif && String(nif).trim() !== "" ? `${nome} (${nif})` : nome;
        },
      },
      {
        Header: "Vendedor",
        accessor: "vendedor",
      },
    ],
    []
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      PaperComponent={PaperComponent}
      PaperProps={{
        sx: {
          width: {
            xs: "calc(100% - 16px)",
            sm: "calc(100% - 32px)",
          },
          maxWidth: "1500px",
          maxHeight: "92vh",
        },
      }}
    >
      <DialogTitle
        className="draggable-dialog-title"
        sx={{
          cursor: "move",
          pr: 6,
          position: "relative",
        }}
      >
        <MDBox display="flex" alignItems="center" gap={1.5}>
          <MaterialImage
            refMaterial={material?.refmaterial}
            imgsByRef={imgsByRef}
            size={42}
            placeholderWidth={42}
          />

          <MDBox>
            <MDTypography variant="h6">Detalhe de faturação</MDTypography>

            <MDTypography variant="caption" color="text">
              {material ? `${material.nomematerial || ""} (${material.refmaterial || ""})` : ""}
            </MDTypography>
          </MDBox>
        </MDBox>

        <IconButton
          aria-label="Fechar"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          p: {
            xs: 1,
            md: 2,
          },
        }}
      >
        <ProjectTable
          tableKey="analise-vendas-material-detalhe"
          version="v1"
          title={`Faturação (${(linhas || []).length.toLocaleString("pt-PT")} linhas)`}
          columns={columns}
          data={linhas || []}
          loading={loading}
          emptyMessage="Sem linhas de faturação para este material."
          minWidth={1450}
          maxHeight="60vh"
          defaultSortBy={[
            {
              id: "faturadata",
              desc: true,
            },
          ]}
          showKeepFilters
        />
      </DialogContent>

      <DialogActions>
        <MDButton variant="outlined" color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default AnaliseVendasMaterialDetalheDialog;
